import { useTranslations } from 'next-intl'

import { PageNotFound } from '@/shared/asset'
import { Link } from '@/shared/i18n'
import { Button } from '@/shared/ui'
import { BottomNavigationBarUI } from '@/widgets/bottom-navigation-bar/client'

export const MobileNotFoundPage = () => {
  const t = useTranslations('common.error')

  return (
    <>
      <div className="flex h-full grow flex-col items-center bg-gray-50 pt-39">
        <PageNotFound className="mb-6 block" />
        <h2 className="typo-headline3 mb-4 font-semibold text-black">
          {t('not_found.title')}
        </h2>
        <p className="typo-label1 mb-6 text-center font-normal whitespace-break-spaces text-gray-900">
          {t('not_found.description')}
        </p>
        <Button
          asChild
          variant="solid"
          color="primary"
          size="medium"
          className="w-45"
        >
          <Link href="/">{t('button.home')}</Link>
        </Button>
      </div>
      <BottomNavigationBarUI pathname="" />
    </>
  )
}
